import Dictionary from './../../utils/dictionary';
export default class AckStore {
    static createOrUpdate(ack) {
        this.stores.set(ack.guid, ack);
    }
    static get(guid) {
        return this.stores.get(guid);
    }
    static remove(ackGuid) {
        this.stores.delete(ackGuid);
    }
}
AckStore.stores = new Dictionary();
//# sourceMappingURL=ackStore.js.map